var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "aside",
    {
      staticClass:
        "article-details__sidebar d-xl-block col-12 col-xl-3 col-xxl-4 d-print-none mt-5 mt-xl-0",
    },
    [
      _c(
        "div",
        { staticClass: "article-details__sidebar-inner" },
        [
          _vm.content.copyright
            ? [
                _vm.content.copyright.author
                  ? _c("div", [
                      _c("h3", {
                        staticClass: "h6 text-container-handheld",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("ui.views.contents.sidebar.author")
                          ),
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "article-details__author ci-content-margin",
                        },
                        [
                          _c("ci-user-tile", {
                            attrs: { user: _vm.content.copyright.author },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm.content.copyright.news_source_url
                  ? [
                      _c("h3", {
                        staticClass: "h6 text-container-handheld",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("ui.views.contents.sidebar.copyright")
                          ),
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "ci-card article-details__sidebar-item ci-content-padding article-details__outlet text-center p-4",
                        },
                        [
                          _c("div", {
                            staticClass: "img bg-center bg-contain",
                            style: {
                              backgroundImage: `url('${_vm.content.copyright.news_source_url}')`,
                            },
                          }),
                        ]
                      ),
                    ]
                  : _vm.content.copyright.company
                  ? [
                      _c("h3", {
                        staticClass: "h6 text-container-handheld",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("ui.views.contents.sidebar.copyright")
                          ),
                        },
                      }),
                      _c("ci-company-tile", {
                        staticClass: "ci-content-margin",
                        attrs: {
                          company: _vm.content.copyright.company,
                          context: "content-sidebar",
                        },
                      }),
                    ]
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.hasRelatedProducts || _vm.hasCompanyData
            ? [
                _c("h3", {
                  staticClass: "h6 text-container-handheld",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("ui.views.contents.sidebar.suitable_to_article")
                    ),
                  },
                }),
                _vm.hasCompanyData
                  ? _c("ci-company-tile", {
                      staticClass: "ci-content-margin",
                      attrs: {
                        company: _vm.content.company,
                        context: "content-sidebar",
                      },
                    })
                  : _vm._e(),
                _vm.hasRelatedProducts
                  ? _c(
                      "div",
                      { staticClass: "row article-details__products" },
                      _vm._l(_vm.relatedProducts, function (product) {
                        return _c(
                          "div",
                          {
                            key: product.id,
                            staticClass: "d-flex col-12 col-md-6 col-xl-12",
                          },
                          [
                            _c("ci-product-tile", {
                              staticClass: "flex-grow-1",
                              attrs: { product: product },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.content.interest_tags && _vm.content.interest_tags.length
            ? [
                _c("h3", {
                  staticClass: "h6 text-container-handheld",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("ui.views.contents.sidebar.tags")
                    ),
                  },
                }),
                _c("ci-interest-tags", {
                  staticClass: "ci-card ci-content-padding",
                  attrs: {
                    "interest-tags": _vm.content.interest_tags,
                    "tag-tracking-target-name": "TagArticleFooter",
                    context: "articles",
                    variant: "link",
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }